import { render } from "./AdminLeadForms.vue?vue&type=template&id=789f6952"
import script from "./AdminLeadForms.vue?vue&type=script&lang=js"
export * from "./AdminLeadForms.vue?vue&type=script&lang=js"

import "./AdminLeadForms.vue?vue&type=style&index=0&id=789f6952&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__